import React from "react";
import styles from "./ExploreFields.module.scss";
import FieldsImg from "../../../../images/ExploreField.png";
import Button from "components/UI/Button/Button";
import { RiArrowRightLine } from "react-icons/ri";
import Avatar1 from "../../../../images/testimonial1.png";
import Avatar2 from "../../../../images/testimonial2.png";
import { useNavigate } from "react-router-dom";

const Testimonial = ({ avatar, feedback }) => {
  return (
    <div className={styles.testimonial}>
      <img src={avatar} alt="Testimonial-1" className={styles.avatar} />
      <div className={styles.comment}>
        <svg
          width="24"
          height="31"
          viewBox="0 0 24 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_2963_7285)">
            <path
              d="M3.0517 15.5938L22.9173 2.9654L23.007 28.08L3.0517 15.5938Z"
              fill="#EDEEFC"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_2963_7285"
              x="0.0517578"
              y="0.965454"
              width="23.9551"
              height="29.1145"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="-1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_2963_7285"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_2963_7285"
                result="shape"
              />
            </filter>
          </defs>
        </svg>

        <div className={styles.feedbackText}>{feedback}</div>
      </div>
    </div>
  );
};

const ExploreFields = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className={styles.exploreFields}>
        <div className={styles.content}>
          <h2 className={styles.title}>Explore Fields</h2>
          <p>
            At Qreativs, we celebrate a diverse pool of talents from every
            field. Our platform is designed to support a wide range of creative
            professionals and freelancers, giving each individual the space to
            grow, connect and contribute to exciting real world projects.
            Whether you are a photographer, content writer or a creative
            director - Qreativs is your playground.
          </p>
          {/* <Button
            className={styles.btn}
            variant="filled"
            onClick={() => {
            }}
          >
            Learn more
            <RiArrowRightLine />
          </Button> */}
        </div>
        <img src={FieldsImg} alt="Field-banner" />
      </section>
      <section className={styles.collaborate}>
        <div>
          <h2>Network. Collaborate. Seek advice</h2>
          <p>
            Explore tags to ideate and discuss with other creatives and work on
            collaborative projects
          </p>
          <div className={styles.btnSection}>
            <Button
              className={styles.btn}
              variant="filled"
              onClick={() => {
                navigate("/feed");
              }}
            >
              Network
              <RiArrowRightLine />
            </Button>
            <Button
              className={styles.btn}
              variant="filled"
              onClick={() => {
                navigate("/feed");
              }}
            >
              Thoughts
              <RiArrowRightLine />
            </Button>
            <Button
              className={styles.btn}
              variant="filled"
              onClick={() => {
                navigate("/feed");
              }}
            >
              Advice
              <RiArrowRightLine />
            </Button>
          </div>
        </div>
        <div>
          <Testimonial
            avatar={Avatar1}
            feedback="Looking for a stylist for an upcoming shoot, follow up with leads."
          />
          <Testimonial
            avatar={Avatar2}
            feedback="How do creative professionals and freelancers in our industry cope with the work structure ?"
          />
        </div>
      </section>
    </>
  );
};

export default ExploreFields;
